import { combineReducers } from "@reduxjs/toolkit";
import packageSlice from "./packageSlice";


const FeatureReducer = combineReducers({
    package:packageSlice
});

export default FeatureReducer;